import { GameWalletProviderOptions, MagicProviderOptions } from '@imtbl/imx-sdk';
import { Magic } from 'magic-sdk';

const buildMagicClient = (config: MagicProviderOptions | GameWalletProviderOptions) =>
    new Magic(config.publishableKey, { network: config.network });

export default buildMagicClient;
